import { ConfigProviderTypeId as ConfigProviderTypeId$1, FlatConfigProviderTypeId as FlatConfigProviderTypeId$1, configProviderTag, make as make$1, makeFlat as makeFlat$1, fromEnv as fromEnv$1, fromFlat as fromFlat$1, fromMap as fromMap$1, constantCase as constantCase$1, mapInputPath as mapInputPath$1, kebabCase as kebabCase$1, lowerCase as lowerCase$1, nested as nested$1, orElse as orElse$1, unnested as unnested$1, snakeCase as snakeCase$1, upperCase as upperCase$1, within as within$1 } from '../../internal/configProvider.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const ConfigProviderTypeId = ConfigProviderTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const FlatConfigProviderTypeId = FlatConfigProviderTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A ConfigProvider is a service that provides configuration given a description
 * of the structure of that configuration.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * The service tag for `ConfigProvider`.
 *
 * @since 2.0.0
 * @category context
 */
const ConfigProvider = configProviderTag;

/**
 * Creates a new config provider.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Creates a new flat config provider.
 *
 * @since 2.0.0
 * @category constructors
 */
const makeFlat = makeFlat$1;

/**
 * A config provider that loads configuration from context variables,
 * using the default System service.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromEnv = fromEnv$1;

/**
 * Constructs a new `ConfigProvider` from a key/value (flat) provider, where
 * nesting is embedded into the string keys.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromFlat = fromFlat$1;

/**
 * Constructs a ConfigProvider using a map and the specified delimiter string,
 * which determines how to split the keys in the map into path segments.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromMap = fromMap$1;

/**
 * Returns a new config provider that will automatically convert all property
 * names to constant case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
const constantCase = constantCase$1;

/**
 * Returns a new config provider that will automatically tranform all path
 * configuration names with the specified function. This can be utilized to
 * adapt the names of configuration properties from one naming convention to
 * another.
 *
 * @since 2.0.0
 * @category utils
 */
const mapInputPath = mapInputPath$1;

/**
 * Returns a new config provider that will automatically convert all property
 * names to kebab case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
const kebabCase = kebabCase$1;

/**
 * Returns a new config provider that will automatically convert all property
 * names to lower case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
const lowerCase = lowerCase$1;

/**
 * Returns a new config provider that will automatically nest all
 * configuration under the specified property name. This can be utilized to
 * aggregate separate configuration sources that are all required to load a
 * single configuration value.
 *
 * @since 2.0.0
 * @category utils
 */
const nested = nested$1;

/**
 * Returns a new config provider that preferentially loads configuration data
 * from this one, but which will fall back to the specified alternate provider
 * if there are any issues loading the configuration from this provider.
 *
 * @since 2.0.0
 * @category utils
 */
const orElse = orElse$1;

/**
 * Returns a new config provider that will automatically un-nest all
 * configuration under the specified property name. This can be utilized to
 * de-aggregate separate configuration sources that are all required to load a
 * single configuration value.
 *
 * @since 2.0.0
 * @category utils
 */
const unnested = unnested$1;

/**
 * Returns a new config provider that will automatically convert all property
 * names to upper case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
const snakeCase = snakeCase$1;

/**
 * Returns a new config provider that will automatically convert all property
 * names to upper case. This can be utilized to adapt the names of
 * configuration properties from the default naming convention of camel case
 * to the naming convention of a config provider.
 *
 * @since 2.0.0
 * @category combinators
 */
const upperCase = upperCase$1;

/**
 * Returns a new config provider that transforms the config provider with the
 * specified function within the specified path.
 *
 * @since 2.0.0
 * @category combinators
 */
const within = within$1;

export { ConfigProvider, ConfigProviderTypeId, FlatConfigProviderTypeId, constantCase, fromEnv, fromFlat, fromMap, kebabCase, lowerCase, make, makeFlat, mapInputPath, nested, orElse, snakeCase, unnested, upperCase, within };
